import { useState } from 'react';
import type { ReactNode } from 'react';
import { Button } from 'reactstrap';

/**
 * `id` is required and every call site passes one (ImageInformation.jsx, three
 * sites). The former `id = undefined` default was a no-op that contradicted the
 * typedef; under `strictNullChecks` the two cannot coexist, and the typedef is
 * what the call sites already satisfy, so the default is gone (SCRUM-1643).
 */
type CopyToClipboardProps = {
  id: string;
  text: string;
  children?: ReactNode;
};

const CopyToClipboard = ({ id, text, children = null }: CopyToClipboardProps) => {
    const [isCopied, setIsCopied] = useState(false);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <>
        <Button
            id={id}
            className="btn btn-sm text-center"
            onClick={copyToClipboard}
        >
            {isCopied ? 'Copied!' : 'Copy'}
        </Button>
        {children}

        </>
    );
};
export default CopyToClipboard;
